export default "__VITE_ASSET__DSGoy3bi__"